module.exports = __webpack_public_path__ + "static/img/noData.808f7a2a.png";